import { ListViewProduct } from 'models/ListViewProduct';
import styles from './styles.scss';
import cn from 'classnames';

interface ContainerProps {
  items?: ListViewProduct[];
  children: (item: ListViewProduct, index: number) => React.ReactNode;
  className?: string;
}

export const Container = ({ items, children, className }: ContainerProps) =>
  (items && (
    <ul className={cn(styles.container, className)}>
      {items &&
        items.map((item, index) => (
          <li key={item.productId} className={styles.item}>
            {children(item, index)}
          </li>
        ))}
    </ul>
  )) as React.FunctionComponentElement<ContainerProps>;
